<div class="yf-row align-left gap-4">
  <ng-container *ngFor="let star of stars">
    <div app-star [isClickable]="isClickable" (starEnter)="onStarEnter($event)" (starLeave)="onStarLeave()"
      (starClicked)="onStarClicked($event)" [rating]="hoverState || rating" [color]="color" [starNumber]="star"></div>
  </ng-container>
</div>
